import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import AddNewEmployee from "../pages/dashboardPage/emloyeeSettings/addNewEmployee/AddNewEmployee";
import AllEmployess from "../pages/dashboardPage/emloyeeSettings/allEmployess/AllEmployees";
import ControlHierarchy from "../pages/dashboardPage/emloyeeSettings/controlHierarchy/ControlHierarchy";
import EditEmployee from "../pages/dashboardPage/emloyeeSettings/editEmployee/EditEmployee";

const EmployeeNavigator = () => {
  const { rolePermissions } = useSelector((state) => state.user);

  return (
    <Routes>
      {rolePermissions.includes("view-admins") && (
        <Route path="/show-all-employees" element={<AllEmployess />} />
      )}
      {rolePermissions.includes("create-admins") && (
        <Route path="/add-new-employee" element={<AddNewEmployee />} />
      )}
      {rolePermissions.includes("update-admins") && (
        <Route path="/edit-employee" element={<EditEmployee />} />
      )}
      {rolePermissions.includes("control-hierarchy") && (
        <Route path="/control-hierarchy" element={<ControlHierarchy />} />
      )}
      {rolePermissions.includes("view-admins") && (
        <Route path="*" element={<AllEmployess />} />
      )}
    </Routes>
  );
};

export default EmployeeNavigator;
